import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import VideosService from "@services/VideosService";

export const initialCreateVideo = {
  name: "",
  product_ids: [],
  country_id: null,
  description: "",
  product_line_id: null,
};

export const createVideo = createAsyncThunk(
  "video/create",
  async ({video}, {rejectWithValue}) => {
    try {
      await VideosService.createVideo({video});

      return null;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  target: initialCreateVideo,
  current: initialCreateVideo,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const createVideoSlice = createSlice({
  name: "create-video",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
      state.isChanged = true;
    },
    setCurrent(state, action) {
      state.current = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearCreate() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createVideo.pending, (state) => {
        pendingState(state);
      })
      .addCase(createVideo.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(createVideo.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setTarget,
  setCurrent,
  setIsChanged,
  setErrors,
  setError,
  setStatus,
  clearCreate,
} = createVideoSlice.actions;
export default createVideoSlice.reducer;
